import styled from "styled-components";
import {InputLabel} from "@mui/material";

export const ExtraLabelText = styled(InputLabel)(()=>({
  '&.MuiFormLabel-root': {
    whiteSpace: 'break-spaces',
    marginBottom: '6px'

  }
}))